/* Theme-only colour selection; existing Shopify variants and native Athens cart. */
if (!customElements.get('tt-variant-card')) {
 customElements.define('tt-variant-card', class extends HTMLElement {
  connectedCallback() {
   if (this.bound) return; this.bound = true;
   this.addEventListener('click', event => {
    const swatch = event.target.closest('[data-tt-swatch]');
    if (!swatch || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (this.querySelector('button.loading')) return;
    event.preventDefault();
    this.querySelectorAll('[data-tt-link]').forEach(a => a.href = swatch.href);
    this.querySelectorAll('[data-tt-swatch]').forEach(a => { a.classList.remove('is-selected'); a.removeAttribute('aria-current'); });
    swatch.classList.add('is-selected'); swatch.setAttribute('aria-current','true');
    const img = this.querySelector('.tt-v-image img');
    if (img && swatch.dataset.image) { img.src = swatch.dataset.image; img.alt = this.dataset.title + ' — ' + swatch.dataset.colour; }
    this.querySelector('[data-tt-colour]').textContent = swatch.dataset.colour;
    this.querySelector('[data-tt-price]').innerHTML = swatch.dataset.price;
    const available = swatch.dataset.available === 'true';
    const label = swatch.dataset.label;
    this.querySelector('[data-tt-stock]').textContent = !available ? 'Sold out' : label === 'Backorder' ? 'Available on backorder' : label === 'Pre-order' ? 'Available to pre-order' : 'Available';
    const input = this.querySelector('input[name=id]');
    if (input) input.value = swatch.dataset.variant;
    const button = this.querySelector('button[type=submit]');
    if (button) { button.disabled = !available; this.querySelector('[data-tt-button-label]').textContent = label; }
    const error = this.querySelector('.product-form-error-message-wrapper'); if(error) error.hidden = true;
   });
  }
 });
}